/**
 * Blank Stock Catalog  v5
 * Asset: assets/blank-catalog.js
 *
 * Flat grid — all options always visible, grouped by category then brand.
 * Handles: CSS injection, category filter, live search.
 * No click/toggle logic.
 */

(function () {
  'use strict';

  var cfg = {};

  function injectCSS() {
    var c = cfg;
    var rules = [
      '#bsc-catalog *{box-sizing:border-box;margin:0;padding:0}',
      '#bsc-catalog{font-family:' + c.body_font + ';background:' + c.page_bg + ';min-height:40vh;padding-left:' + c.page_side_padding + ';padding-right:' + c.page_side_padding + '}',

      '.bsc-topbar{background:' + c.topbar_bg + ';border-bottom:1px solid ' + c.topbar_border + ';padding:14px 24px}',
      '.bsc-store-name{font-size:16px;font-weight:500;color:' + c.topbar_text + ';font-family:' + c.heading_font + '}',

      '.bsc-body{max-width:960px;margin:0 auto;padding:24px 0}',

      '.bsc-search{width:100%;max-width:300px;padding:8px 12px;font-size:14px;border:1px solid #ddd;border-radius:8px;margin-bottom:14px;font-family:inherit;color:' + c.topbar_text + ';background:#fff;display:block}',
      '.bsc-search:focus{outline:none;border-color:#999}',

      '.bsc-filter-row{display:flex;gap:6px;flex-wrap:wrap;margin-bottom:24px}',
      '.bsc-filter-btn{padding:5px 14px;border-radius:999px;border:1px solid ' + c.filter_inactive_border + ';background:' + c.filter_inactive_bg + ';color:' + c.filter_inactive_text + ';font-size:13px;cursor:pointer;font-family:inherit;transition:background 0.12s,color 0.12s,border-color 0.12s}',
      '.bsc-filter-btn:hover{border-color:#aaa;color:#333}',
      '.bsc-filter-btn.active{background:' + c.filter_active_bg + ';color:' + c.filter_active_text + ';border-color:' + c.filter_active_bg + '}',

      '.bsc-section{padding-bottom:24px !important;border-bottom:1px solid ' + c.card_border + ';margin-top:28px !important;margin-bottom:24px !important}',
      '.bsc-section:first-of-type{margin-top:0}',
      '.bsc-section.hidden{display:none}',
      '.bsc-section-label{font-size:' + c.section_label_size + 'px;font-weight:600;color:' + c.section_label_color + ';letter-spacing:.04em;text-transform:uppercase;margin-bottom:8px}',

      '.bsc-brand-label{font-size:15px;font-weight:700;color:' + c.product_name_color + ';margin:14px 0 10px}',

      '.bsc-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:12px;margin-bottom:8px}',

      '.bsc-card{background:' + c.card_bg + ';border:1px solid ' + c.card_border + ';border-radius:' + c.card_radius + 'px;overflow:hidden}',
      '.bsc-card.hidden{display:none}',
      '.bsc-card-img{width:100%;height:' + c.card_image_height + ';object-fit:cover;display:block}',
      '.bsc-img-placeholder{width:100%;height:' + c.card_image_height + ';background:' + c.placeholder_bg + ';display:flex;align-items:center;justify-content:center;color:' + c.placeholder_color + '}',
      '.bsc-card-body{padding:10px 12px 12px !important}',
      '.bsc-card-name{font-size:13px;font-weight:500;color:' + c.product_name_color + ';margin-bottom:2px}',
      '.bsc-card-desc{font-size:12px;color:' + c.product_desc_color + ';line-height:1.4}',

      '.bsc-empty{font-size:14px;color:#aaa;padding:12px 0}',

      '@media(max-width:520px){',
      '  .bsc-topbar{padding:12px 16px}',
      '  .bsc-body{padding:16px 0}',
      '  .bsc-grid{grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:8px}',
      '}',
    ];
    var style = document.createElement('style');
    style.textContent = rules.join('\n');
    document.head.appendChild(style);
  }

  function sortBrands() {
    document.querySelectorAll('#bsc-catalog .bsc-section').forEach(function (section) {
      var children = Array.prototype.slice.call(section.children);
      var pairs = [];
      var i = 0;
      while (i < children.length) {
        var node = children[i];
        if (node.classList.contains('bsc-brand-label')) {
          var grid = children[i + 1];
          if (grid && grid.classList.contains('bsc-grid')) {
            pairs.push({ label: node, grid: grid, name: node.textContent.trim().toLowerCase() });
            i += 2;
            continue;
          }
        }
        i++;
      }
      if (pairs.length < 2) return;
      pairs.sort(function (a, b) { return a.name.localeCompare(b.name); });
      pairs.forEach(function (pair) {
        section.appendChild(pair.label);
        section.appendChild(pair.grid);
      });
    });
  }

  function applyFilter(activeCat, query) {
    var q          = (query || '').toLowerCase().trim();
    var sections   = document.querySelectorAll('#bsc-catalog .bsc-section');
    var noResults  = document.getElementById('bsc-no-results');
    var anyVisible = false;

    sections.forEach(function (section) {
      var catMatch = activeCat === 'All' || section.dataset.category === activeCat;
      if (!catMatch) { section.classList.add('hidden'); return; }

      var cards   = section.querySelectorAll('.bsc-card');
      var visible = 0;
      cards.forEach(function (card) {
        var name = card.dataset.name || '';
        var desc = card.dataset.desc || '';
        var show = !q || name.indexOf(q) > -1 || desc.indexOf(q) > -1;
        card.classList.toggle('hidden', !show);
        if (show) visible++;
      });

      if (visible === 0) {
        section.classList.add('hidden');
      } else {
        section.classList.remove('hidden');
        anyVisible = true;
      }
    });

    if (noResults) noResults.style.display = anyVisible ? 'none' : '';
  }

  function init() {
    var root = document.getElementById('bsc-catalog');
    if (!root) return;

    var defaults = {
      heading_font:           'inherit',
      body_font:              'inherit',
      topbar_bg:              '#ffffff',
      topbar_border:          '#e8e8e5',
      topbar_text:            '#1a1a1a',
      page_bg:                '#f9f9f7',
      page_side_padding:      '16px',
      card_image_height:      '180px',
      card_bg:                '#ffffff',
      card_border:            '#e8e8e5',
      card_radius:            '10',
      product_name_color:     '#1a1a1a',
      product_desc_color:     '#666666',
      product_meta_color:     '#999999',
      filter_inactive_bg:     'transparent',
      filter_inactive_text:   '#666666',
      filter_inactive_border: '#dddddd',
      filter_active_bg:       '#1a1a1a',
      filter_active_text:     '#ffffff',
      section_label_color:    '#1a1a1a',
      section_label_size:     '18',
      placeholder_bg:         '#f2f2f0',
      placeholder_color:      '#cccccc',
    };
    cfg = Object.assign({}, defaults, window.BSC_CONFIG || {});

    injectCSS();

    var activeCat = 'All';
    var search    = document.getElementById('bsc-search');

    sortBrands();

    root.querySelectorAll('.bsc-filter-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('.bsc-filter-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        activeCat = btn.dataset.cat || 'All';
        applyFilter(activeCat, search ? search.value : '');
      });
    });

    if (search) {
      search.addEventListener('input', function () {
        applyFilter(activeCat, search.value);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
